import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

const FIELD =
  'w-full rounded-sharp border border-line bg-bg px-2.5 text-ink placeholder:text-ink-faint ' +
  'transition-colors hover:border-line-bright focus:border-accent focus:outline-none ' +
  'disabled:cursor-not-allowed disabled:opacity-50';

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn(FIELD, 'h-9 font-mono text-xs', className)} />;
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={cn(FIELD, 'py-2 text-xs leading-relaxed', className)} />;
}

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      {...props}
      className={cn(
        FIELD,
        'h-9 cursor-pointer appearance-none font-mono text-[11px] uppercase tracking-[0.08em]',
        className,
      )}
    >
      {children}
    </select>
  );
}

export function Field({
  label,
  hint,
  error,
  children,
}: {
  label: string;
  hint?: string;
  error?: string | null;
  children: React.ReactNode;
}) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="label-xs">{label}</span>
      {children}
      {error ? (
        <span className="font-mono text-[11px] text-alert">{error}</span>
      ) : hint ? (
        <span className="font-mono text-[11px] text-ink-faint">{hint}</span>
      ) : null}
    </label>
  );
}
